/**
 * pdfjs-dist worker URL registration — side-effect import from main.tsx.
 *
 * Day 10: slimmed to avoid pulling the whole pdfjs-dist library into the
 * main bundle. Previously this file did `import * as pdfjs from "pdfjs-dist"`
 * which anchored the ~700KB library into the initial chunk via main.tsx.
 * Now we only import the worker URL (Vite transforms `?url` to a static
 * string at build time) and hand it to the engine's setPdfWorkerUrl
 * registration function. The actual pdfjs-dist library is dynamically
 * imported on first parse by packages/engine-ts/src/parsers.ts, which
 * keeps it lazy all the way through.
 */

import { setPdfWorkerUrl } from "@talent-align/engine";
import workerSrc from "pdfjs-dist/build/pdf.worker.min.mjs?url";

setPdfWorkerUrl(workerSrc as string);
